import '../vue_widget_wrapper.js.coffee'

Namespace 'Monitoring.Views.Charts'

class Monitoring.Views.Charts.TopicCloudAIView extends Monitoring.Views.Charts.VueWidgetWrapper

  className: 'item word-ranking h2 w2'
  jobName: 'llm_words'

  initialize: (@options = {}) ->
    super($.extend(@options, {
      widget: 'new-cloud',
      title: I18n.t('monitoring.dashboard.charts.topic_cloud_ai.title'),
      menu: {
        options: [
          {
            text: 'Download PNG image',
            event: 'download-png-image'
          }
        ]
      }
    }))

    @base64Wordcloud = null
    @calculator = @options.calculator
    @calculator.on("calculate_#{@jobName}", @updateWidgetData)
    @menuEvents = {
      'download-png-image': @downloadPNGImage
    }
    @widgetEvents = {
      'export-data-changed': @updateExportData,
      'open-new-session': @openPartialDrilldown
    }

  afterAppend: =>
    @notifyAnalytics()
    job = @calculator.calculate(@jobName, 99)
    job.bind('failed', @displayError) if job

  notifyAnalytics: =>
    params = {}
    dateFromRealtime = @searchQuery.get('date_from_realtime')
    if dateFromRealtime
      params.date_filter_type = 'realtime'
      params.date_filter_value = dateFromRealtime.value
    else
      params.date_filter_type = 'fixed_range'
    analyticsEvents.socialContentsTopicsDiscovery(params)

  updateWidgetData: (data) =>
    @vueSortableBoundWidget.update({
      isLoading: false,
      data: {
        topicRanking: data.topic_ranking,
        supplementByTopic: {},
        metricsSpecification: []
      }
    })
    @trigger('masonry')

  updateExportData: (base64) =>
    @base64Wordcloud = base64

  downloadPNGImage: =>
    link = document.createElement('a')
    link.href = @base64Wordcloud
    link.download = 'topics-cloud.png'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

  openPartialDrilldown: (topic) =>
    contentIds = topic.content_ids
    searchQuery = @searchQueryFor(contentIds)
    @createPreviewDashboard(searchQuery) # TODO: que no sean visibles los botones de summary y crear sesión

  searchQueryFor: (contentIds) =>
    query = @searchQuery.deepCopy()
    query.set('content_id', contentIds)
    query
